module.exports = __webpack_public_path__ + "static/img/featrue4.5e46bb42.jpg";